/**
 * The assistant's ring mark, from the canvas (`bs.css`'s bubble and header
 * glyph): an open ring, a dot riding it, and a dot at the centre. Drawn with
 * tokens rather than the canvas's hex so both themes hold it. Decorative: every
 * control it sits in carries its own name.
 */
export function AssistantMark({ size = 26 }: { size?: number }) {
  return (
    <svg className="assistant-mark" width={size} height={size} viewBox="0 0 26 26" fill="none" aria-hidden="true">
      <circle className="assistant-mark__ring" cx="13" cy="13" r="9.5" strokeWidth="2" strokeDasharray="44 16" strokeLinecap="round" />
      <circle className="assistant-mark__orbit" cx="20" cy="7" r="2.6" />
      <circle className="assistant-mark__core" cx="13" cy="13" r="2" />
    </svg>
  )
}
